module.exports = __webpack_public_path__ + "img/f4-2.a99ad64b.png";